import { Col, Empty, Row, Select } from "antd";
import type {
  FnUpdateInvitePerson,
  InvitePerformanceEvaluationDetailItem,
} from "../../type";
import { useState } from "react";
import { usePageSubDeptEmployeesQuery } from "@/hooks/services";
import { useDebounceCallback } from "usehooks-ts";
import { useTranslation } from "react-i18next";

type EmployeeSelectProps = {
  deptNo: string;
  rater: number | null;
  onInvitePersonChange: FnUpdateInvitePerson;
};

const EmployeeSelect: React.FC<EmployeeSelectProps> = ({
  deptNo,
  rater,
  onInvitePersonChange,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const debouncedSetSearchValue = useDebounceCallback(setSearchValue, 500);
  const { t } = useTranslation("supplierPerformance");

  const { employeeList } = usePageSubDeptEmployeesQuery({
    pageNum: 1,
    pageSize: 100,
    deptNo,
    searchValue: searchValue,
  });

  const options = employeeList.map((e) => ({
    label: e.nickName,
    value: e.id,
  }));

  const handleSearch = (newValue: string) => {
    debouncedSetSearchValue(newValue);
  };

  return (
    <Select
      showSearch
      filterOption={false}
      value={rater}
      options={options}
      placeholder={t("请选择考核人")}
      onSearch={handleSearch}
      onChange={(value) => {
        setSearchValue("");
        onInvitePersonChange(deptNo, value);
      }}
    ></Select>
  );
};

type Props = {
  inviteDetails: InvitePerformanceEvaluationDetailItem[];
  onInvitePersonChange: FnUpdateInvitePerson;
};

export function EvaluationInvite({
  inviteDetails,
  onInvitePersonChange,
}: Props) {
  const { t } = useTranslation("supplierPerformance");

  const invites = Array.from(
    new Map(inviteDetails.map((item) => [item.ratingDeptId, item])).values(),
  );
  return (
    <div style={{ marginTop: "20px", minHeight: 250, paddingLeft: 10 }}>
      {invites.length === 0 && <Empty description={t("无需邀请其他考核人")} />}
      <Row gutter={[16, 16]}>
        {invites.map((i) => (
          <Col key={i.indicatorId} span={24}>
            <Row align={"middle"}>
              <Col span={8}>
                <Row align={"middle"}>
                  <Col>{t("考核部门")}：</Col>
                  <Col span={16}>{i.ratingDeptName}</Col>
                </Row>
              </Col>
              <Col span={8}>
                <Row align={"middle"}>
                  <Col>{t("考核人")}：</Col>
                  <Col span={12}>
                    <EmployeeSelect
                      deptNo={i.ratingDeptId}
                      rater={i.rater}
                      onInvitePersonChange={onInvitePersonChange}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
    </div>
  );
}
